import React from 'react'
import { connect } from 'react-redux';
import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { display } from 'src/utils/Utils';
import styles from './EmployeeRemarksShow.scss'

const EmployeeRemarksShow = props => {
    const { employee } = props;
    return (
        <div className={styles.remarksContainer}>
            {display(employee.remarks)}
        </div>
    );
};

export default connect(state => ({
    employee: selector(getItem(REDUCER_NAME, state), 'employee')
}))(EmployeeRemarksShow);
